import { useState, useEffect } from 'react';

export const useGeolocation = (setCity, setSearchInput) => {
  const [showLocationPrompt, setShowLocationPrompt] = useState(false);

  useEffect(() => {
    const getLocation = async () => {
      try {
        if (!navigator.geolocation) {
          setCity("Madrid");
          setSearchInput("Madrid");
          setShowLocationPrompt(true);
          return;
        }

        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => resolve(pos),
            (error) => {
              setCity("Madrid");
              setSearchInput("Madrid");
              setShowLocationPrompt(true);
              reject(error);
            },
            { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
          );
        });

        const { latitude, longitude } = position.coords;
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
        );

        if (!response.ok) throw new Error("Failed to get location name");

        const data = await response.json();
        const cityName = data.address?.city || data.address?.town || "Madrid";
        const country = data.address?.country || "";
        const locationString = country ? `${cityName}, ${country}` : cityName;

        setCity(cityName);
        setSearchInput(locationString);
      } catch (error) {
        setShowLocationPrompt(true);
        setCity("Madrid");
        setSearchInput("Madrid");
      }
    };

    getLocation();
  }, [setCity, setSearchInput]);

  return { showLocationPrompt, setShowLocationPrompt };
};

export default useGeolocation;
